

import React, { useEffect, useState } from 'react';

const SocialWall = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Prüfe ob das Script bereits existiert
    const existingScript = document.querySelector('script[src*="flockler.com"]');
    if (existingScript) {
      setIsLoaded(true);
      return;
    }

    // Script dynamisch laden, wenn die Komponente gemountet wird
    const script = document.createElement('script');
    script.src = 'https://plugins.flockler.com/embed/17010aa4fb1051298cefd0a5566021b9/19980b2a5520f40f76e1cfc03816f9b5';
    script.async = true;
    
    // Event Listener für erfolgreiches Laden
    script.onload = () => {
      setIsLoaded(true);
      
      // Verhindere automatisches Abspielen von Videos
      setTimeout(() => {
        const videos = document.querySelectorAll('#flockler-embed-19980b2a5520f40f76e1cfc03816f9b5 video');
        videos.forEach(video => {
          video.muted = true; // Stummschalten
          video.preload = 'metadata'; // Nur Metadaten laden
          
          // Entferne autoplay Attribut falls vorhanden
          if (video.hasAttribute('autoplay')) {
            video.removeAttribute('autoplay');
          }
        });
      }, 1000);
    };
    
    script.onerror = () => {
      console.warn('Flockler script konnte nicht geladen werden');
    };
    
    // Script zum DOM hinzufügen
    document.head.appendChild(script);
    
    // Cleanup-Funktion: Script entfernen, wenn Komponente unmounted wird
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []); // Leeres Dependency-Array = läuft nur beim ersten Mount

  return (
    <section className="social-wall" id="social">
      <h2>Social Wall</h2>
      {!isLoaded && (
        <div className="social-wall-loading">
          <p>Loading social media posts...</p>
        </div>
      )}
      <div 
        id="flockler-embed-19980b2a5520f40f76e1cfc03816f9b5"
        style={{ opacity: isLoaded ? 1 : 0, transition: 'opacity 0.3s ease' }}
      ></div>
    </section>
  );
};

export default SocialWall;
